import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import ProductCard from '../main_compos/ProductCard';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Navigation from '../header_footer/Navgation';
import Footer from '../header_footer/Footer';

export default function Search() {
  const { t } = useTranslation();
  const localhost = process.env.REACT_APP_LOCALHOST;

  const [searchQuery, setSearchQuery] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (query, page = 1) => {
    if (query.trim() === '') {
      setFilteredProducts([]);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(`${localhost}search-products`, {
        params: { query: query, page: page },
      });

      const updatedData = response.data.data.map(item => {
        const category = item.category ? JSON.parse(item.category) : null;
        const imgs = item.imgs ? JSON.parse(item.imgs) : null;
        return { ...item, category, imgs };
      });

      setFilteredProducts(updatedData);
      setCurrentPage(response.data.current_page);
      setTotalPages(response.data.last_page);
    } catch (err) {
      // console.error('Error fetching products:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePagination = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    handleSearch(searchQuery, page);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch(searchQuery, 1);
  };

  return (
    <section>
      <Navigation />
      <main className="container mx-auto pt-10 sm:pt-16 p-4">
        <div className="text-center">
          <form onSubmit={handleSubmit} className="flex items-center max-w-2xl mx-auto gap-2">
            <div className="relative w-full">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder={t("search-products") + "..."}
                className="w-full px-4 py-2.5 pl-12 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-black/5 focus:border-black/40"
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <MagnifyingGlassIcon className="w-5 h-5 text-gray-400" />
              </div>
            </div>
            <button
              type="submit"
              className="text-white bg-black border border-black hover:bg-black/80 px-4 py-2 rounded-lg"
            >
              {t("search")}
            </button>
          </form>
        </div>

        <div className="my-5">
          {searchQuery && (
            <div className="mb-2 text-sm text-gray-600">
              {filteredProducts.length} {t("results-found")} "{searchQuery}"
            </div>
          )}

          {loading ? (
            <div className="min-h-[55vh] flex justify-center items-center">
              <div className="loading-spinner" />
            </div>
          ) : filteredProducts.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4 md:gap-8 lg:grid-cols-4">
              {filteredProducts.map((item) => (
                <ProductCard key={item.id} item={item} />
              ))}
            </div>
          ) : (
            <div className="text-center flex items-center justify-center min-h-[60vh]">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{t("no-found-title")}</h3>
                <p className="text-gray-600">{t("no-found-text")}</p>
              </div>
            </div>
          )}
        </div>

        <div className="flex items-center justify-center gap-4 my-8">
          <button
            onClick={() => handlePagination(currentPage - 1)}
            disabled={currentPage === 1}
            className="inline-flex items-center text-sm font-medium transition-colors rounded-sm
              disabled:opacity-30 disabled:cursor-not-allowed
              bg-white text-black/80
              hover:bg-gray-50 hover:text-black
              focus:outline-none focus:ring-1 focus:ring-orange-500 focus:ring-offset-2"
          >
            <ChevronLeftIcon className="size-6" />
          </button>

          <div className="flex items-center text-sm font-medium text-black/80">
            <span className="px-3 py-1 rounded-lg bg-black/5">{currentPage}</span>
            <span className="mx-2">{t("of")}</span>
            <span className="px-3 py-1 rounded-lg bg-black/5">{totalPages}</span>
          </div>

          <button
            onClick={() => handlePagination(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="inline-flex items-center text-sm font-medium transition-colors rounded-sm
              disabled:opacity-30 disabled:cursor-not-allowed
              bg-white text-black/80
              hover:bg-gray-50 hover:text-black
              focus:outline-none focus:ring-1 focus:ring-orange-500 focus:ring-offset-2"
          >
            <ChevronRightIcon className="size-6" />
          </button>
        </div>
      </main>
      <Footer />
    </section>
  );
}
